import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { ReportsComponent } from "./reports.component";
import { TaskExecutionReportComponent } from "./task-execution-report/task-execution-report.component";
import { RunnersReportComponent } from "./runners-report/runners-report.component";
import { TasksReportComponent } from "./tasks-report/tasks-report.component";
import { ReportsRoutingModule } from "./reports-routing.module";
import { MatToolbarModule } from "@angular/material/toolbar";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { SettingsRoutingModule } from "../settings/settings-routing.module";
import { MatIconModule } from "@angular/material/icon";
import { MatTableModule } from "@angular/material/table";
import { MatCardModule } from "@angular/material/card";
import { MatButtonModule } from "@angular/material/button";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { MatFormField, MatLabel } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { AuditReportComponent } from "./audit-report/audit-report.component";
import { AuditReportComponent as LibAuditReportComponent } from "@nucleus/audit-report-ui";
import { NUCLEUS_AUDIT_UI_PROVIDERS } from "../services/audit-ui-adapters";
import { MailReportComponent as LibMailReportComponent } from "@nucleus/mail-report-ui";
import { NUCLEUS_MAIL_UI_PROVIDERS } from "../services/mail-ui-adapters";
import { MailTemplateManagerComponent } from "@nucleus/mail-template-ui";
import { MailTemplatesComponent } from "./mail-templates/mail-templates.component";
import { MatDividerModule } from "@angular/material/divider";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatChipsModule } from "@angular/material/chips";
import { JsonPathViewerComponent } from "../common/json-path-viewer/json-path-viewer.component";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatSelectModule } from "@angular/material/select";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { FilterAutocompleteComponent } from "@nucleus/ui-base";
import { MailReportComponent } from "./mail-report/mail-report.component";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatMenuModule } from "@angular/material/menu";
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import { PageHeaderComponent } from "@nucleus/ui-base";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { ComingSoonComponent } from '@nucleus/ui-common';




@NgModule({
    providers: [...NUCLEUS_AUDIT_UI_PROVIDERS, ...NUCLEUS_MAIL_UI_PROVIDERS],
    declarations: [
        ReportsComponent,
        TaskExecutionReportComponent,
        RunnersReportComponent,
        TasksReportComponent,
        AuditReportComponent,
        MailReportComponent,
        MailTemplatesComponent
    ],
    bootstrap: [ReportsComponent],
    imports: [
        RouterModule,
        MatToolbarModule,
        ReactiveFormsModule,
        CommonModule,
        FormsModule,
        MatIconModule,
        MatTableModule,
        MatCardModule,
        MatButtonModule,
        MatTooltipModule,
        MatProgressBarModule,
        MatPaginatorModule,
        MatSortModule,
        MatFormField,
        MatLabel,
        MatDividerModule,
        MatSidenavModule,
        MatChipsModule,
        MatInputModule,
        MatSelectModule,
        MatDatepickerModule,
        JsonPathViewerComponent,
        MatAutocompleteModule,
        FilterAutocompleteComponent,
        MatMenuModule,
        MatBottomSheetModule,
        PageHeaderComponent,
        MatProgressSpinnerModule,
        MatCheckboxModule,
        ComingSoonComponent,
        LibAuditReportComponent,
        LibMailReportComponent,
        MailTemplateManagerComponent,
        ReportsRoutingModule
    ]
})
export class ReportsModule {}
